export enum TSHTTPEvent {
    REQUEST_FINISHED = <any> 'REQUEST_FINISHED',
}



// WEBPACK FOOTER //
// ./src/app/core/events/TSHTTPEvent.ts